import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import DriverInfoAndTruckCoUpdateModal from './DriverInfoAndTruckCoUpdateModal';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import PickupOrderGha from '../../../models/PickupOrderGha';
import DriverTruckEdit from '../../../models/DriverTruckEdit';

interface DriverInfoAndTruckCoUpdateModalProps { 
  modalOpen: boolean;
  selectedDrvTrkData: DriverTruckEdit;
  handleClose: (updated?: boolean) => void;
  receiveSuccess: (message: string) => void;
  receiveError: (error: ResponseError) => void;
};

interface DriverInfoAndTruckCoUpdateModalState { 
  updatedDrvTrkData: DriverTruckEdit;
};

class DriverInfoAndTruckCoUpdateModalContainer extends Component <DriverInfoAndTruckCoUpdateModalProps, DriverInfoAndTruckCoUpdateModalState> {
  
  state = {
    updatedDrvTrkData: {
      orderNumber: '',
      delivery_company_name: '',
      delivery_company_name_new: '',
      driver_id: '',
      driver_id_type: '',
      driver_name: '',
      driver_vehichle_registration: '',
      rfs_number: ''

    }
  };

  componentDidMount() {
    
    if (this.props.selectedDrvTrkData) {
      this.setState({ updatedDrvTrkData: this.props.selectedDrvTrkData });
    }
  };

  handleChange = (field: string, event: any): void => {

    const value: string = event.target.value;
    const updatedDrvTrkData: DriverTruckEdit = { ...this.state.updatedDrvTrkData };

    switch (field) {
      case 'delivery_company_name_new': updatedDrvTrkData.delivery_company_name_new = value; break;
      case 'driver_vehichle_registration': updatedDrvTrkData.driver_vehichle_registration = value; break;
      case 'rfs_number': updatedDrvTrkData.rfs_number = value; break;
      case 'driver_name': updatedDrvTrkData.driver_name = value; break;
      case 'driver_id': updatedDrvTrkData.driver_id = value; break;
      case 'driver_id_type': updatedDrvTrkData.driver_id_type = value; break;
    }
  
    this.setState({ updatedDrvTrkData });
  };

  handleUpdate = (): void => {

    pickupOrderRemote.saveGhaExportDriverInfo(this.state.updatedDrvTrkData.orderNumber, this.state.updatedDrvTrkData).then((resp: ApiResponse<PickupOrderGha>) => {

      const po: PickupOrderGha | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (po) {
        this.props.handleClose(true);
      }
      
      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  render() {

    return (
      <DriverInfoAndTruckCoUpdateModal
        modalOpen={ this.props.modalOpen }
        handleChange={ this.handleChange }
        handleClose={ this.props.handleClose }
        handleUpdate={ this.handleUpdate }
        selectedDrvTrkData={ this.state.updatedDrvTrkData }
      />
    )
  };
};


const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess:(message: string) => dispatch(receiveSuccess(message))
  };
};

export default connect(null, mapDispatchToProps)(DriverInfoAndTruckCoUpdateModalContainer);